"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m0 6.196 5.858-.021 1.13-2.908.493 1.494-.937 2.412-3.77.013 2.973 2.449-.879 3.386 3.097-2.083 3.112 2.094-.84-3.375 2.998-2.431-3.724-.038C9.36 6.848 7.813 2.84 7.484 1.99L7.965.753l2.113 5.44 5.922.06v.018l-4.638 3.762 1.313 5.28-4.71-3.17-4.728 3.182L4.62 10 0 6.196Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m.02 9.454 8.753-.03 1.743-4.486.553 1.68-1.526 3.927-6.4.023 5.05 4.158-1.497 5.764 5.238-3.525 5.257 3.538-1.428-5.739 5.09-4.129-6.52-.066-2.4-6.174-.011.03-.602-1.558.614-1.579 3.172 8.165 8.882.089-6.961 5.645 1.961 7.882-7.054-4.748-7.073 4.761 2.063-7.944L.02 9.454Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m.026 12.605 11.67-.04 2.324-5.981.739 2.241-2.035 5.236-8.534.03 6.733 5.543-1.996 7.686 6.984-4.7 7.01 4.717-1.905-7.651 6.788-5.505-8.694-.088-3.199-8.233-.016.04-.802-2.077.818-2.105 4.23 10.886 11.842.119-9.28 7.527 2.614 10.509-9.406-6.33-9.43 6.348 2.75-10.594-9.205-7.578Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m.093 18.987 17.508-.062 3.712-9.552.923 2.8-3.35 8.623-13.588.048 10.72 8.826-3.182 12.25 11.103-7.473 11.134 7.494-3.032-12.19 10.805-8.764-13.834-.14L23.939 7.79l-.013.033-1.003-2.597 1.016-2.613 6.361 16.37 17.7.18v.057L34.147 30.456l3.92 15.762-14.13-9.51-14.16 9.53 4.123-15.88L.094 18.986Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m.125 25.316 23.343-.083 4.949-12.736 1.23 3.735-4.466 11.495-18.117.065L21.357 39.56l-4.241 16.333 14.803-9.964 14.845 9.992-4.043-16.254L57.13 27.982l-18.447-.187-6.764-17.408-.017.045-1.336-3.463 1.354-3.484 8.48 21.827 23.598.24v.076L45.53 40.608l5.227 21.015-18.84-12.68-18.881 12.708 5.498-21.176L.125 25.316Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconStar = function IconStar(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Star' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Star"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconStar.sizes = [16, 24, 32, 48, 64];
IconStar.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconStar;
exports.default = _default;